import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";

// Public Pages
import HomePage from "./Pages/Home";
import Complaints from "./Pages/Complaints";
import Organisationteam from "./Pages/Organisationteam";
import Newsevent from "./Pages/newsevent";
import Leaders from "./Pages/Leaders";
import Gallerys from "./Pages/Gallery";
import Aboutcmpranesh from "./Pages/About-CMPranesh";
import Newseventdetails from "./Pages/newseventdetails";
import CMNewsSection from "./Pages/CMNewsSection";
import NewsDetails from "./Pages/CMNewsDetails";
import VideoPopup from "./Components/VideoPopup";

// Public Components
import Header from "./Components/Header";
import FooterSection from "./Components/FooterSection";
import ScrollToTop from "./Components/ScrollToTop";
import FloatingButtons from "./Components/FloatingButtons";
import UniqueLoader from "./Components/UniqueLeafLoader";



// Component wrapper to detect admin routes
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />

      {/* Show these ONLY on public routes */}
      {!isAdminRoute && <Header />}
      {!isAdminRoute && <VideoPopup />}
      
      {children}

      {!isAdminRoute && <FooterSection />}
      {!isAdminRoute && <FloatingButtons />}
    </>
  );
};

function App() {
  const [loading, setLoading] = useState(true);

  // Loader simulation
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <UniqueLoader />;

  return (
    <Router>
      <LayoutWrapper>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/membership" element={<Complaints />} />
          <Route path="/organisationteam" element={<Organisationteam />} />
          <Route path="/event" element={<Newsevent />} />
          <Route path="/leaders" element={<Leaders />} />
          <Route path="/gallery" element={<Gallerys />} />
          <Route path="/news" element={<CMNewsSection />} />
          <Route path="/news/:id" element={<NewsDetails />} />
          <Route path="/about-cmpranesh" element={<Aboutcmpranesh />} />
          <Route path="/post/:id" element={<Newseventdetails />} />
        </Routes>
      </LayoutWrapper>
    </Router>
  );
}

export default App;
